import React, { useState, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './assets/kamilkoc-logo.svg';
import { useLocation } from 'react-router-dom';


function App() {

  const params = new URLSearchParams(useLocation().search);

  useEffect(async () => {
    const manifest = await getCurrentManifest();
    loadCss(manifest.css);
    loadScript(manifest.js, () => initSearchMaskComponent());
  });

  const getCurrentManifest = async () => {
    const manifest = await (await fetch("https://d3k6pebee3cv6.cloudfront.net/search-mask/current/asset-manifest.json")).json()
    return {
      css: `https://d3k6pebee3cv6.cloudfront.net/search-mask/current/${manifest["main.css"]}`,
      js: `https://d3k6pebee3cv6.cloudfront.net/search-mask/current/${manifest["main.js"]}`
    }
  }

  const loadScript = (url, callback) => {
    const body = document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    script.onload = function () {
      callback();
    };
    body.appendChild(script);
  }

  const loadCss = (url) => {
    const head = document.head;
    const link = document.createElement('link');
    link.innerHTML = '';
    link.rel = "stylesheet";
    link.href = url;
    head.appendChild(link);
  }


  function useQuery(keys) {
    const urlQuery = new URLSearchParams(useLocation().search);
    const result = {};

    keys.forEach(k => {
      result[k] = urlQuery.get(k);
    });

    return result;
  }

  const initSearchMaskComponent = () => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 1).getTime() / 1000;
    const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 1).getTime() / 1000;
    window['searchMaskComponent'].mount({
      theme: 'kamil',
      initialSearchMaskValues: {
        departureCity: '99c50ec5-3ecb-11ea-8017-02437075395e',
        arrivalCity: 'e76a49b0-c196-4c4e-92ce-9f63f14adc16',
        departureDate: today,
        returnDate: tomorrow,
      },
      includeWebtrekkParameters: true,
      searchResultsHost: 'shop.flixbus.com.tr',
      handleOwnRequestSearchEvent: true,
      locale: 'tr'
    });


    var search = params;
    var flixParams = null;
    if (Array.from(search).length > 0) {
      flixParams = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
    }
    window["searchMaskComponent"].addParameterCallback(() => flixParams);
  }

  return (
    <div className="App">
      <div className="backImg d-none d-sm-block d-sm-none d-md-block">
        <div className="container">
          <div className="row pt-2"></div>
          <div className="row">
            <div className="col-md-2 w6rem bgGray">
              <span className="helper"></span>
              <img src={logo} alt="Kamil Koç" />
            </div>
            <div className="col-md-10"></div>
          </div>
        </div>
      </div>

      <div className="container mt-8rem d-none d-sm-block d-sm-none d-md-block">
        <div className="row">
          <div className="col-md-12">
            <h1 className="beyaz font30">
              Kamil Koç FlixBus İş Ortağı
            </h1>
          </div>
        </div>
      </div>

      <div className="d-block d-sm-none d-none d-sm-block d-md-none mobilHeader">
        <div className="row h100">
          <div className="col-md-12 mt-auto mb-auto">
            <div className="beyaz text-center">
              Kamil Koç - Otobüs Bileti Al
            </div>
          </div>
        </div>
      </div>

      <div id="search-mask-component"></div>

      <div className="container m-menu-p black">
        <br />
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>
                Türkiye’nin lider ve öncü karayolu yolcu taşıma şirketi Kamil Koç artık Avrupa’nın en büyük
                şehirlerarası otobüs ağını kuran ve pazar lideri FlixBus’ın iş ortağı!
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12 bgBeyaz mt-4 mb-3 font14">
              <p>Kamil Koç, FlixBus iş ortaklığıyla sunduğu konforlu ve kaliteli seyahat deneyimine ek olarak, teknolojik
                hizmetlerini yeni bir seviyeye taşıyacak ve herkes için akıllı bir seyahat seçeneği sunarak yoluna devam
                edecek. 94 yıldır Türkiye’nin birçok ilinde hizmet veren Kamil Koç’la artık Avrupa’nın 35 ülkesine de
                FlixBus iş ortağımızla seyahat edilebilecek. </p>

              <p>Kâmil Koç, 2019 yılında Avrupa’nın en büyük şehirlerarası otobüs ağını kuran FlixBus’ın iş ortağı
                olmuştur. 2013 yılından beri 100 milyondan fazla yolcusuna hizmet veren FlixBus bugün 35 ülkede
                2.500’den fazla güzergâhı birbirine bağlayarak herkes için çevreci ve akıllı seyahat imkanı sunmaktadır.
              </p>

              <p>Kamil Koç, FlixBus iş ortaklığıyla sunduğu konforlu ve kaliteli seyahat deneyimine ek olarak, teknolojik
                hizmetlerini yeni bir seviyeye taşıyacak ve Türkiye’de 60 il ve 288 ilçede sunduğu seyahat noktasını iş
                ortağı ile birlikte Avrupa’nın 35 ülkesine kadar genişletecek. </p>

              <p>1 Aralık 2020 tarihi itibariyle gerçekleşecek seyahatler için Kamil Koç online biletlerinizi iş ortağımız
                FlixBus’ın altyapısıyla <a href="https://www.flixbus.com.tr">yenilenen web sitemizden</a> güvenle ve pratik bir şekilde satın alabilir, konforlu
                seyahatler gerçekleştirebilirsiniz.
              </p>
              <hr />
              {/* <div className="shadow col-10 col-md-12 ml-auto mr-auto"></div> */}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default App;
